import React from 'react';

import ScreenWrapper from '../features/Theme/ScreenWrapper';
import AddFundsCardPaymentProvider1Select from '~/components/features/AddFundsCardPaymentProvider1Select';
type Props = {
    currentAmount?: string;
    setActiveRightTab?: Function;
    setPaymentProvider1Method?: Function;
    setPaymentProvider1Currency?: Function;
};
export default function AddFundsCardPaymentProvider1SelectScreen({
    setActiveRightTab,
    setPaymentProvider1Method,
    currentAmount,
    setPaymentProvider1Currency,
}: Props) {
    return (
        <ScreenWrapper>
            <AddFundsCardPaymentProvider1Select
                setActiveRightTab={setActiveRightTab}
                setPaymentProvider1Method={setPaymentProvider1Method}
                currentAmount={currentAmount}
                setPaymentProvider1Currency={setPaymentProvider1Currency}
            />
        </ScreenWrapper>
    );
}
